export const RFInitialValues = {
  searchType: '0',
  searchValue: '',
  dateFilter: '1',
  categ: {
    notDisbursed: 2,
    closed: 2,
    writtenOff: 2,
    stopped: 0,
    expired: 0,
    secured: 0,
  },
  branchesDisabled: true,
  branchId: 1,
  productsDisabled: true,
  productId: 2,
  tagsDisabled: true,
  tagId: 1,
}

export const RF_NAME = 'LOANS'

export const LOANS_FETCHER_NAME = 'LOANS'

export const LK_GRID_NAME = 'LOANS'
export const formName = 'frm_loan_search'
export const objectName = 'dbgrd_loan_list'
